var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTgShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 53,
    viewBox: "0 0 61 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 51C38.031 51 49 40.031 49 26.5C49 12.969 38.031 2 24.5 2C10.969 2 0 12.969 0 26.5C0 40.031 10.969 51 24.5 51Z",
    fill: "url(#paint0_linear_8732_51064)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0908 26.2414C18.2331 23.1296 22.9957 21.0782 25.3787 20.087C32.1826 17.257 33.5964 16.7654 34.5179 16.7492C34.7205 16.7456 35.1737 16.7959 35.4672 17.034C35.7151 17.2352 35.7833 17.5068 35.8159 17.6975C35.8486 17.8882 35.8892 18.3226 35.8569 18.662C35.4882 22.536 33.8928 31.9373 33.0812 36.2763C32.7377 38.1123 32.0615 38.7279 31.4068 38.7881C29.984 38.919 28.9037 37.8478 27.5257 36.9445C25.3693 35.531 24.1512 34.6511 22.0581 33.2718C19.6392 31.6778 21.2072 30.8017 22.5858 29.3699C22.9465 28.9952 29.2153 23.2933 29.3366 22.776C29.3518 22.7114 29.3658 22.4702 29.2226 22.3429C29.0793 22.2156 28.8679 22.2591 28.7153 22.2937C28.4991 22.3428 25.0543 24.6197 18.3811 29.1243C17.4033 29.7957 16.5177 30.1228 15.7242 30.1057C14.8494 30.0868 13.1667 29.6111 11.9157 29.2044C10.3814 28.7057 9.16198 28.442 9.26816 27.595C9.32347 27.1538 9.93102 26.7026 11.0908 26.2414Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8732_51064",
    x1: 2450,
    y1: 2,
    x2: 2450,
    y2: 4865.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgShort);
export default __webpack_public_path__ + "static/media/tg-short.dc9600f11cf1eee01215b41597769724.svg";
export { ForwardRef as ReactComponent };